var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8666",
    "data-name": "Rectangle 8666",
    width: 8.488,
    height: 7.275,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Up_Next"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Up_Next",
    "data-name": "Up Next",
    clipPath: "url(#clip-Up_Next)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_622",
    "data-name": "Ellipse 622",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1 1)",
    fill: "#f99e1e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10865",
    "data-name": "Group 10865",
    transform: "translate(13.744 13.275) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10750",
    "data-name": "Group 10750",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20166",
    "data-name": "Path 20166",
    d: "M0,3.556a.9.9,0,0,1,.292-.467Q1.736,1.65,3.176.207a.611.611,0,0,1,.7-.156A.6.6,0,0,1,4.092.99c-.031.038-.066.074-.1.109-.451.451-2.066,1.93-2.064,1.937h.093q2.9,0,5.792,0a.64.64,0,0,1,.5.182.567.567,0,0,1,.138.626.606.606,0,0,1-.539.4,1.435,1.435,0,0,1-.149,0H1.921c0,.005,1.551,1.419,2.092,1.96a.628.628,0,0,1,.172.71.593.593,0,0,1-.9.235,1.37,1.37,0,0,1-.123-.111Q1.726,5.613.293,4.181A.93.93,0,0,1,0,3.722Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpNext);
export default __webpack_public_path__ + "static/media/Up Next.e93a11a702c147f6bbbde208354654ca.svg";
export { ForwardRef as ReactComponent };